import { observer } from 'mobx-react';
import React from 'react';
import '../css/partes.css';
import { RepresentanteDto } from '../../modelo/dto/PartesDto';
import { IRepresentante } from '../../modelo/Partes';

interface IProps {
    representantes: IRepresentante[];
}

export const ViewTableRepresentante = observer(class ViewTableRepresentante extends React.Component<IProps> {
    render() {
        return (
            <div>
                {this.props.representantes && this.props.representantes.map(function (rep, index) {
                    let registroComplementar = '';

                    if (rep.registroComplementar) {
                        registroComplementar = ' (' + rep.registroComplementar + ')';
                    }

                    return (
                        <div className="lista-align-left" key={index}>
                            <div className="titulo">
                                {rep.tipo}
                            </div>
                            <div className="lista-align-left">
                                {(rep.nomeSocial || rep.nome) + (registroComplementar)}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
});
